export const removeHyphen = (phoneNumber: string) => {
  return phoneNumber.replace(/-/g, '');
};

export const autoHyphen = (phoneNumber: string) => {
  if (phoneNumber.length >= 13) return phoneNumber.slice(0, 13);
  return phoneNumber
    .replace(/[^0-9]/g, '')
    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
    .replace(/(\-{1,2})$/g, '');
};
